import { QueryClient } from '@tanstack/react-query';

/** Cliente de métricas: stale 2 min, sin refetch agresivo al focus (datos mensuales). */
export function createMetricsQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 2 * 60 * 1000,
        gcTime: 15 * 60 * 1000,
        retry: 1,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true,
      },
    },
  });
}
